import React from "react";
import ChargebackVolumeChart from "./ChargebackVolumeChart";
import ChargebackScoreCard from "./ChargebackScoreCard";
import SlidingTab from "../../../../components/SlidingTab/SlidingTab";
import useChargebackStore from "../../../../stores/chargeback";
import styles from "./styles.module.scss";

function ChargebackCharts() {
  const volumeFilter = useChargebackStore((state) => state.volumeFilter);
  const setVolumeFilter = useChargebackStore((state) => state.setVolumeFilter);

  return (
    <div className={styles.container}>
      <div className={styles.charts}>
        <div className={styles.volumeChartContainer}>
          <div className={styles.volumeChartHeader}>
            <h5>Chargebacks volume</h5>
            <div className={styles.volumeChartButtons}>
              <SlidingTab
                selectedTab={
                  volumeFilter.type.charAt(0).toUpperCase() +
                  volumeFilter.type.slice(1)
                }
                options={["Volume", "Amount"]}
                onChange={(tab) => {
                  setVolumeFilter({ type: tab.toLowerCase() });
                }}
                fullWidth
              />
            </div>
          </div>
          <ChargebackVolumeChart />
        </div>

        <ChargebackScoreCard />
      </div>
    </div>
  );
}

export default ChargebackCharts;
